export const APPLE_AFFILIATE_TOKEN = import.meta.env.VITE_APPLE_AFFILIATE_TOKEN || '';
export const APPLE_AFFILIATE_ENABLED = APPLE_AFFILIATE_TOKEN.length > 0;

const APPLE_MUSIC_SUBSCRIBE_BASE = 'https://music.apple.com/subscribe';

export function getAppleMusicSubscribeUrl(campaign?: string): string {
  if (!APPLE_AFFILIATE_TOKEN) {
    return `${APPLE_MUSIC_SUBSCRIBE_BASE}?app=music&ls=1`;
  }

  const params = new URLSearchParams({
    app: 'music',
    at: APPLE_AFFILIATE_TOKEN,
    ls: '1',
  });

  if (campaign) {
    params.set('ct', campaign);
  }

  return `${APPLE_MUSIC_SUBSCRIBE_BASE}?${params.toString()}`;
}
